import { createGlobalState } from "@vueuse/core";
import { computed, readonly, ref } from "vue";

export function buildResumeWidgetUrl(rawUrl: string): string {
  try {
    const widgetUrl = new URL(rawUrl);
    widgetUrl.searchParams.set("targetId", "container");

    if (widgetUrl.searchParams.get("destination[mode]") === "bp") {
      widgetUrl.searchParams.set("destination[mode]", "none");
    }

    return widgetUrl.href;
  } catch {
    console.warn(`[widgetModalState] Failed to parse widget URL: ${rawUrl}`);
    return rawUrl;
  }
}

const useWidgetModalState = createGlobalState(() => {
  const url = ref("");
  const isOpen = computed(() => !!url.value);

  const origin = computed(() => {
    if (!url.value) return null;

    try {
      return new URL(url.value).origin;
    } catch {
      return null;
    }
  });

  const open = (widgetUrl: string) => {
    url.value = widgetUrl;
  };

  const close = () => {
    url.value = "";
  };

  return {
    isOpen,
    url: readonly(url),
    origin,
    open,
    close,
  };
});

export default useWidgetModalState;
